<template>
  <v-navigation-drawer
    :value="isSidebarDataAPIActive"
    temporary
    touchless
    :right="!$vuetify.rtl"
    width="350"
    app
    @input="val => $emit('update:is-sidebar-data-api-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center">
        <h4 class="font-weight-semibold text-base">
          API
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-sidebar-data-api-active', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text class="pt-5">
        <v-form ref="stepForm">
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="api.api_name"
                :label="`${$t('lbl.name')}`"
                outlined
                dense
                hide-details="auto"
                :rules="textRequiered"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="api.key"
                label="KEY"
                outlined
                dense
                hide-details="auto"
                :rules="textRequiered"
              ></v-text-field>
            </v-col>

            <fragment v-if="api.slug === 'redsys'">
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="api.mercantil_code"
                  :label="`${$t('lbl.merchantCode')}`"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="textRequiered"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="api.terminal"
                  :label="`${$t('lbl.merchantTerminal')}`"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="textRequiered"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-select
                  v-model="api.currency"
                  :items="currencies"
                  item-text="name"
                  item-value="id"
                  :label="$t('lbl.currency')"
                  outlined
                  clearable
                  dense
                  hide-details
                ></v-select>
              </v-col>
            </fragment>

            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="api.url_prod"
                label="URL"
                outlined
                dense
                hide-details="auto"
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-file-input
                v-model="logo"
                accept="image/*"
                show-size
                outlined
                dense
                label="Logo"
                hide-details
                @change="setLogo"
              ></v-file-input>
            </v-col>

            <v-col
              cols="12"
              md="12"
            >
              <v-textarea
                v-model="api.description"
                :label="$t('lbl.description')"
                outlined
                rows="3"
                row-height="3"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="error"
                block
                @click="$emit('update:is-sidebar-data-api-active', false)"
              >
                {{ $t('btn.cancele') }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="primary"
                outlined
                block
                :disabled="camposVerify"
                :loading="loadingBtn"
                @click="$emit('confirmEdit')"
              >
                {{ $t('btn.send') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'
import { mdiClose } from '@mdi/js'

export default {
  model: {
    prop: 'isSidebarDataAPIActive',
    event: 'update:is-sidebar-data-api-active',
  },
  props: {
    isSidebarDataAPIActive: {
      type: Boolean,
      required: true,
    },
    api: {
      type: Object,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop, vue/prop-name-casing
    type_api: {
      type: String,
    },
  },
  data() {
    return {
      stepForm: null,
      icons: {
        mdiClose,
      },
      textRequiered: [v => !!v || 'Campo requerido'],
      emailRules: [v => !!v || 'Campo requerido', v => /.+@.+/.test(v) || 'E-mail debe ser válido'],
      phoneRules: [v => Number.isInteger(Number(v)) || 'Debe ser solo números'],
      loading: false,
      logo: null,
      currencies: [],
    }
  },
  computed: {
    ...mapState({
      clientCarShop: state => state.app.clientCarShop,
      loadingBtn: state => state.app.loadingBtn,
      carItems: state => state.app.carItems,
    }),
    camposVerify() {
      let rest = false
      if (!this.api.api_name || !this.api.key || !this.api.url_prod) {
        rest = true
      }

      return rest
    },
  },
  created() {
    this.currencies.push({
      id: '840',
      name: 'USD',
    })
    this.currencies.push({
      id: '978',
      name: 'EUR',
    })
  },
  methods: {
    setLogo() {
      if (this.logo) {
        const formData = new FormData()
        formData.append('logo', this.logo)
        this.axios
          .post('api_extern/upload-logo', formData, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          })
          .then(res => {
            if (res.data.success === true) {
              this.api.logo = res.data.data.dir
            }
          })
          .catch(error => console.log(error))
      }
    },
  },
}
</script>
